import script from "./ProductEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProductEdit.vue?vue&type=style&index=0&id=5cb46d5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb46d5c"]])

export default __exports__